import {IconProps} from './types';

const Comments = ({fill = 'currentColor', className, width = 20, height = 20}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        className={className}
    >
        <path
            d="M4.167 15.833V13.333H2.5C2.042 13.333 1.649 13.17 1.32 12.842C0.993 12.514 0.833 12.121 0.833 11.667V3.333C0.833 2.875 0.993 2.482 1.32 2.158C1.649 1.83 2.042 1.667 2.5 1.667H13.333C13.792 1.667 14.185 1.83 14.513 2.158C14.84 2.482 15 2.875 15 3.333V8.333H13.333V3.333H2.5V11.667H5.833V14.167L8.333 11.667H10V13.333H8.917L4.167 15.833Z"
            fill={fill}
        />
        <path
            d="M11.667 16.667V14.583H10V10H17.5V14.583H14.167L11.667 16.667ZM11.667 13.333H15.833V11.667H11.667V13.333Z"
            fill={fill}
        />
    </svg>
);

export default Comments;
